
export default class Events {

    pushDataLayer(dataLayer) {
      if (!window.dataLayer) window.dataLayer = []

      // if (window !== window.parent) {
      //   console.log('此為 iframe 中的資料層事件:', dataLayer)
      // } else {
      //   console.log('推送資料層事件:', dataLayer)
      // }

      window.dataLayer.push(dataLayer)
    }

  // 推送 "hasConsented" 事件
  async push_click_aibot_agree() {
    this.pushDataLayer({
      event: 'click_aibot_agree'
    })
  }

  // 推送 "chatbotStart" 事件
  async push_click_aibot_start() {
    this.pushDataLayer({
      event: 'click_aibot_start'
    })
  }

  getExposedMethods() {
    return {
      push_click_aibot_agree: this.push_click_aibot_agree.bind(this),
      push_click_aibot_start: this.push_click_aibot_start.bind(this)
    }
  }
}


// WEBPACK FOOTER //
// ./src/plugins/gtm/datalayer/Events.js